// extracted by mini-css-extract-plugin
export default {"excursionList":"ExcursionList_excursionList__F8fxA"};